

angular
.module('inkfinder')
.factory('InvitationFactory', function InvitationFactory(
  $http,
  $rootScope,
  ENDPOINT,
  AlertMessages
) {
  // Public functions
  InvitationFactory.createInvitation = createInvitation;
  InvitationFactory.updateInvitation = updateInvitation;
  InvitationFactory.getInvitation = getInvitation;
  InvitationFactory.updateAccount = updateAccount;
  InvitationFactory.updateAccount = updateAccount;

  /**
  * @description Create an invitation
  * @param {object} association The associaiton to base the invitation off of
  * @return {object} Returns the created invitation
  */
  function createInvitation(association) {
    return $http.post(ENDPOINT.server +
    'collectors/api/v1.1/invitation/', association)
      .then(function(response) {
        return response.data;
      }, function(error) {
        AlertMessages.add({
          msg: error,
          type: 'danger'
        });
      });
  }

  /**
  * @description
  * Update the invitation
  * @param {object} invitation The invitation to update
  * @return {object} Returns the updated invitation
  */
  function updateInvitation(invitation) {
    return $http.put(ENDPOINT.server + 'collectors/api/v1.1/invitation/' +
    invitation.id + '/', invitation)
    .then(function(response) {
      return response.data;
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
  * @description
  * Get the invitation by passing the token
  * @param {string} token The token to determine the invited user
  * @return {object} Returns the collector, associations, and invitation
  */
  function getInvitation(token) {
    return $http.get(ENDPOINT.server +
    'collectors/api/v1.1/invitation/?token=' + token)
    .then(function(response) {
      return response.data;
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
  * @description
  * Update the collector account by passing the token
  * @param {object} profile The collector profile to update.
  * @return {object} Returns the updated collector profile.
  */
  function updateAccount(profile) {
    return $http.post(ENDPOINT.server +
    'collectors/api/v1.1/invitation/update-account/', profile)
    .then(function(response) {
      return response.data;
    }, function(error) {
      AlertMessages.add({
        msg: error.data,
        type: 'danger'
      });
    });
  }
  return InvitationFactory;
});



// WEBPACK FOOTER //
// ./components/invitation/invitation.factory.js